export const MACHPRO_ALERT_CLOSE = 'MACHPRO_ALERT_CLOSE';
